// extracted by mini-css-extract-plugin
export default {"form-switch-container":"FormSwitch_form-switch-container__CAvJd"};